"use client";

import posthog from "posthog-js";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmailForPostHog(raw: string): string {
	return raw.trim().toLowerCase();
}

export function isValidEmailForPostHog(raw: string): boolean {
	return EMAIL_RE.test(normalizeEmailForPostHog(raw));
}

export type PosthogEmailDedupeRef = { current: string | null };

/**
 * posthog.identify with normalized email as distinct_id. Skips if email invalid,
 * PostHog throws, or dedupe ref already holds this normalized address.
 * @returns whether identify ran
 */
export function identifyPosthogByEmail(
	rawEmail: string,
	extraProps: Record<string, unknown>,
	dedupeRef: PosthogEmailDedupeRef,
): boolean {
	const id = normalizeEmailForPostHog(rawEmail);
	if (!id || !EMAIL_RE.test(id)) {
		return false;
	}
	if (dedupeRef.current === id) {
		return false;
	}
	try {
		posthog.identify(id, { email: id, ...extraProps });
	} catch {
		return false;
	}
	dedupeRef.current = id;
	return true;
}
